<template>
 
  <div class="">
    <!-- ======================== Sambutan ========================  -->
    <div class="q-my-xxs q-py-xl q-px-xl bg-gray-3" v-if="$q.screen.lt.sm">
      <div class="row justify-between">
      <div class="text-h6 text-weight-bolder text-black">Indeks Daya Saing Daerah</div>
      <div class="text-h6" style="font-size: 12px;">Beranda / <span class="text-secondary">Indeks Daya Saing Daerah</span></div>
      </div>
    </div>

    <div class="q-my-xxs q-py-xl q-px-xl text-center bg-grey-3" v-if="$q.screen.sm || $q.screen.md || $q.screen.lg || $q.screen.xl">
      <div class="row justify-between">
      <div class="text-h6 text-weight-bolder text-black">Indeks Daya Saing Daerah</div>
      <div class="text-h6" style="font-size: 12px;">Beranda / <span class="text-secondary">Indeks Daya Saing Daerah</span></div>
      </div>
    </div>

    <div class="row wrap justify-between items-start content-start ">
      <!-- <div class="q-pa-xl row q-col-gutter-lg"> -->
      <div class="col-12 col-md-12 col-sm-12 col-xs-12 q-pa-md q-gutter-y-lg items-end">
      <div class="col-12 q-pa-lg" id="idsd">
      </div>
      </div>
    </div>

  </div>     
</template>

<script>
export default {
  data() {
         return {
      data_load: false,
      form: {
        id: "",
        nilai: "",
        isi: "",
        file: "",
        createBy: "",
      },
      persistent : false,

      list_data: [],
      idsd: [],
      page_first: 1,
      page_last: 0,
      cari_value: "",
    };
    },
    methods: {

    getIdsd: function() {
        fetch(this.$store.state.URL_MANIS + "idsd", {
          method: "GET",
          headers: {
            "content-type": "application/json",
          },

        })
          .then(res => res.json())
          .then(res_data => {
            console.log(res_data);
              this.idsd = res_data.data;

             var idsd = [];
             var idsdk = [];
             var hasil = this.idsd;
             console.log(hasil);

             for(var i in hasil) {
                 idsd.push({"name" : hasil[i].tahun, "y" : hasil[i].jumlah, "z" : hasil[i].ket});
                 idsdk.push(hasil[i].ket);
             }

             console.log(idsdk);


             this.grafikIdsd(idsd, idsdk);
          });
    },

    // ================== PAGINASI ====================
    alertku: function (type, title) {
      this.$swal({
        type: type,
        title: title,
        showConfirmButton: false,
        timer: 800,
      });
    },

    btn_prev: function () {
      if (this.page_first > 1) {
        this.page_first--;
      } else {
        this.page_first = 1;
      }
      this.getView();
    },

    btn_next: function () {
      if (this.page_first >= this.page_last) {
        this.page_first == this.page_last;
      } else {
        this.page_first++;
      }
      this.getView();
    },

    cari_data: function () {
      this.page_first = 1;
      this.getView();
    },

    grafikIdsd: function(idsd, idsdk) {

      Highcharts.chart('idsd', {
        chart: {
            type: 'column'
        },
        title: {
            text: 'Data Indeks Daya Saing Daerah Kabupaten Konawe Selatan'
        },
        subtitle: {
            text: 'Sumber : Badan Riset & Inovasi Daerah Kabupaten Konawe Selatan'
        },
        xAxis: {
            type: 'category',
            labels: {
                rotation: -45,
                style: {
                    fontSize: '13px',
                    fontFamily: 'Verdana, sans-serif'
                }
            }
        },
        yAxis: {
            min: 0,
            title: {
                text: 'Indeks Daya Saing Daerah'
            }
        },
        legend: {
            enabled: false
        },
        tooltip: {
            pointFormat: 'Indeks Daya Saing Daerah <b>{point.z}</b> : <b>{point.y:.2f}</b>'
        },
        series: [{
            name: 'Indeks Daya Saing Daerah',
            colors: [
                '#9b20d9', '#9215ac', '#861ec9', '#7a17e6', '#7010f9', '#691af3',
                '#6225ed', '#5b30e7', '#533be1', '#4c46db', '#4551d5', '#3e5ccf',
                '#3667c9', '#2f72c3', '#277dbd', '#1f88b7', '#1693b1', '#0a9eaa',
                '#03c69b',  '#00f194'
            ],
            colorByPoint: true,
            groupPadding: 0,
            data: idsd,
            dataLabels: {
                enabled: true,
                rotation: -90,
                color: '#FFFFFF',
                align: 'right',
                format: '{point.y:.2f}', // one decimal
                y: 10, // 10 pixels down from the top
                style: {
                    fontSize: '13px',
                    fontFamily: 'Verdana, sans-serif'
                }
            }
        }]
      });

    },

    // ================== PAGINASI ====================
  },
  // =============================================================== METHODS =========================================================================

  mounted() {
    this.getIdsd();
  },

}
</script>
